import { tagsManagers } from '../managers';
import { ITagOption } from '@cian/ui-kit';
import { IExtractorParams } from '../types/params';

export const restoreTagsFromJsonQuery = (params: IExtractorParams) =>
  tagsManagers.flatMap(tag => tag.extractTagsFromJsonQuery(params)?.flat()).filter(Boolean) as ITagOption[];
